<template>
  <div class="wrapper">
    <h2 class="component-title">{{ $t('choosePaymentMethod') }}</h2>
    <p :class="['about-next-step', isZkm && 'about-next-step-zkm']">
      {{ $t('finishPaymentInNextStep') }}
    </p>
    <div class="payment-methods">
      <div
        :class="[
          'payment-method',
          isZkm && 'payment-method-zkm',
          selected === 1 && 'selected-method',
        ]"
        @click=";(selected = 1), $emit('paymentMethod', 'CreditCard')"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{ determineButtonType(1) }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">{{ $t('cardPayment') }}</h3>
            <p class="payment-about">{{ $t('onlinePaymentWspay') }}</p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/all-cards.svg" alt="Bank-cards" />
        </div>
      </div>
      <div
        v-if="event.id === '905'"
        :class="[
          'payment-method',
          isZkm && 'payment-method-zkm',
          selected === 2 && 'selected-method',
        ]"
        @click=";(selected = 2), $emit('paymentMethod', 'KeksPay')"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{ determineButtonType(2) }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">KEKS Pay</h3>
            <p class="payment-about">
              {{ $t('keksPayDesc') }}
            </p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/Keks_pay.svg" alt="Keks pay" />
        </div>
      </div>
      <div
        v-if="hidePaycek"
        :class="[
          'payment-method',
          isZkm && 'payment-method-zkm',
          selected === 3 && 'selected-method',
        ]"
        @click=";(selected = 3), $emit('paymentMethod', 'PayCek')"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{ determineButtonType(3) }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">PAYCEK</h3>
            <p class="payment-about">{{ $t('cryptoPayment') }}</p>
          </div>
        </div>
        <div class="payment-logo">
          <img src="/assets/paycek-logo.svg" alt="Paycek-logo" />
        </div>
      </div>
      <div
        v-if="isGiftCardPaymentEnabled"
        :class="[
          'payment-method',
          isZkm && 'payment-method-zkm',
          isGiftCardSelected && 'selected-method',
        ]"
        @click=";(isGiftCardSelected = !isGiftCardSelected), $emit('paymentMethod', 'GiftCard')"
      >
        <div class="payment-description">
          <div class="check-box">
            <span class="material-icons">
              {{ isGiftCardSelected ? 'check_box' : 'check_box_outline_blank' }}
            </span>
          </div>
          <div class="payment-text">
            <h3 class="payment-type">{{ $t('giftCardPayment') }}</h3>
            <p class="payment-about">{{ $t('giftCardPaymentDescription') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-method',
  props: ['event', 'isTotalPriceZero', 'tickets'],
  data() {
    return {
      selected: 1,
      isGiftCardSelected: false,
    }
  },
  computed: {
    isZkm() {
      return this.event.organization.id == process.env.VUE_APP_ZKM_ORGANIZATION_ID
    },
    isGiftCardPaymentEnabled() {
      return !!this.event.eventTemplateId && !this.isTotalPriceZero
    },
    hidePaycek() {
      const ticketIds = this.tickets.map(t => t.ticketId)

      return !ticketIds.some(id => [8591, 8593].includes(Number(id)))
    },
  },
  methods: {
    determineButtonType(option) {
      if (this.isGiftCardPaymentEnabled) {
        return this.selected === option ? 'check_box' : 'check_box_outline_blank'
      }

      return this.selected === option ? 'check_circle' : 'radio_button_unchecked'
    },
  },
}
</script>

<style scoped>
.payment-methods {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}

.payment-method {
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 1.125rem;
  width: 100%;
  min-height: 85px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #979797;
}

.payment-method-zkm {
  max-width: inherit !important;
}

@media screen and (max-width: 455px) {
  .payment-method {
    flex-direction: column !important;
    align-items: flex-start !important;
  }

  .payment-logo {
    align-self: center;
  }
}

.check-box {
  margin-right: 1.125rem;
  margin-top: 5px;
}

.payment-description {
  display: flex;
}

.payment-logo {
  margin-right: 1.5rem;
}

.component-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  margin-bottom: 1rem;
  margin-top: 1.375rem;
}

.wrapper {
  margin-bottom: 2rem;
}

.selected-method {
  color: #0277bd;
  border: 1px solid #0277bd !important;
}

.payment-text {
  padding-right: 0.25rem;
}

.about-next-step {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #666666;
}

.about-next-step-zkm {
  padding-bottom: 2rem;
}

.payment-type {
  font-weight: 500;
  font-size: 20px;
}

.payment-about {
  margin-top: 0.5rem;
  font-weight: 400;
  font-size: 16px;
}
</style>
